export enum SectionName {
  ProductsShelf = 'ProductsShelf',
  SearchShelf = 'SearchShelf',
  CollectionShelf = 'CollectionShelf',
}
